import { Switch, Route } from 'react-router-dom'
import SignInPage from 'pages/Auth/SignInPage'

const AuthRouter = () => (
  <Switch>
    <Route path="/" component={SignInPage} />
    <Route exact path="/sign-in" component={SignInPage} />
  </Switch>
)

export default AuthRouter
